import React, { Fragment } from 'react';
import Translation from '../Translation';
let plugwrapTableHeader = [
    {
        title: <Translation labelName="lbl_name" defaultText="Name" />,
        dataIndex: 'name',
        key: 'name',
        onFilter: (value, record) => {
            return (record.name.toLowerCase().includes(value.toLowerCase()))
        },
        defaultSortOrder: 'ascend',
        sorter: (a, b) => {
            if (a.name < b.name) { return -1; }
            if (a.name > b.name) { return 1; }
            return 0;
        }
    },
    {
        title: <Translation labelName="tbl_hdr_manifacturer" defaultText="Manufacturer" />,
        dataIndex: 'manufacturer',
        key: 'manufacturer',
        onFilter: (value, record) => {
            return (record.manufacturer.toLowerCase().includes(value.toLowerCase()))
        },
        sorter: (a, b) => {
            if (a.manufacturer < b.manufacturer) { return -1; }
            if (a.manufacturer > b.manufacturer) { return 1; }
            return 0;
        }
    },
    {
        title: <Translation labelName="tbl_hdr_coresta_porosity" defaultText="CORESTA Porosity" />,
        dataIndex: 'corpor',
        key: 'corpor',
        sorter: (a, b) => {
            return a.corpor - b.corpor;
        }
    },
    {
        title: <Translation labelName="plugwrap_tbl_hdr_wrap" defaultText="Wrap Type" />,
        dataIndex: 'wrapType',
        key: 'wrapType',
        onFilter: (value, record) => {
            return (record.wrapType.toLowerCase().includes(value.toLowerCase()))
        },
        sorter: (a, b) => {
            if (a.wrapType < b.wrapType) { return -1; }
            if (a.wrapType > b.wrapType) { return 1; }
            return 0;
        }
    },
    {
        title:<Fragment><Translation labelName="hdr_plugwrap_tbl_hdr_thickness" defaultText="Thickness" /> (<Translation labelName="units_lbl_mm" defaultText="mm" />)</Fragment>,
        dataIndex: 'thick',
        key: 'thick',
        sorter: (a, b) => {
            return a.thick - b.thick;
        }
    },
    {
        title: <Fragment><Translation labelName="lbl_hdr_weight" defaultText="Weight" /> (<Translation labelName="units_g_m2" defaultText="g/m2" />)</Fragment>,
        dataIndex: 'weight',
        key: 'weight',
        sorter: (a, b) => {
            return a.weight - b.weight;
        }
    },
];

export default plugwrapTableHeader;


// WEBPACK FOOTER //
// ./src/model/PlugwrapTableHeader.js